import { Box, Button, Flex, Grid, Heading, Link } from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useHistory, useParams } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import AllOffersTable from '../components/AllOffersTable';
import Header from '../components/Header';
import ViewOffers from '../components/ViewOffers';
import { getTowerService } from '../services/towerService';
import { getTwitterInfo, getTwitterInfoById } from '../services/twitter';
import { ELECTION_BETTING_END_DATE } from '../utils/Election';

interface ParamTypes {
  twitterScreenName: string;
}

const INFLUENCERS = [
  'MartyBent',
  'francispouliot_',
  'F_D_KB',
  'jimmysong',
  'The_Fizz2',
  'BrainHarrington',
  'BitcoinMagazine',
  'ethan_vera',
  'Chris_Stewart_5',
  'DavidFBailey',
  'basecan',
  'hodled',
  'pierre_rochard',
  'beasteverything',
  'daskalov',
  'ck_SNARKs',
  'jodobear',
];

const InfluencerSelectCard = ({
  twitterScreenName,
  selectedTwitterScreenName,
  onSelectInfluencer,
}) => {
  const [twitterInfo, setTwitterInfo] = useState<any | undefined>({
    name: twitterScreenName,
    profile_image_url_https:
      'https://abs.twimg.com/sticky/default_profile_images/default_profile_400x400.png',
  });

  const selected =
    selectedTwitterScreenName.toLowerCase() === twitterScreenName.toLowerCase();

  useEffect(() => {
    getTwitterInfo(twitterScreenName).then(setTwitterInfo);
  }, [twitterScreenName]);

  if (!twitterInfo) return <></>;

  return (
    <Flex
      onClick={() => onSelectInfluencer(twitterScreenName)}
      cursor="pointer"
      alignItems="center"
      p={4}
      bg="white"
      mx="auto"
      w="325px"
      height="70px"
      borderRadius="4px"
      border={selected ? '1px solid #6873e5' : ''}
      boxShadow={selected ? '0 2px 4px 0 rgba(180, 180, 180, 0.5)' : ''}
    >
      <Box
        mr={4}
        borderRadius={100}
        boxSize="50px"
        bg="#EBEBEB"
        flexShrink={0}
        background={`url(${twitterInfo.profile_image_url_https.replace(
          'normal',
          '200x200'
        )})`}
        backgroundSize="cover"
      ></Box>
      <Box maxW="inherit">
        <Box
          h="20px"
          w="225px"
          overflow="hidden"
          whiteSpace="nowrap"
          fontWeight="bold"
          textOverflow="ellipsis"
        >
          {twitterInfo.name}
        </Box>
        <Box
          textAlign="center"
          fontSize="xs"
          w="225px"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          h="20px"
        >
          {twitterInfo.description}
        </Box>
      </Box>
    </Flex>
  );
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 991 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 991, min: 600 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 2,
  },
};

const ButtonGroup = (props) => {
  const { next, previous } = props;

  return (
    <>
      <Button
        left="-3rem"
        bottom="0"
        top="0"
        margin="auto"
        position="absolute"
        background="rgba(103, 114, 229, 1)"
        minWidth="43px"
        outline="0"
        transition="all .5s"
        borderRadius="35px"
        className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
        onClick={() => previous()}
      />
      <Button
        position="absolute"
        background="rgba(103, 114, 229, 1)"
        minWidth="43px"
        right="-3rem"
        bottom="0"
        top="0"
        margin="auto"
        outline="0"
        transition="all .5s"
        borderRadius="35px"
        className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
        onClick={() => next()}
      />
    </>
  );
};

export const SelectInfluencerCarousel = ({
  onSelectInfluencer,
  selectedTwitterScreenName,
}) => {
  const allOffersSelected = selectedTwitterScreenName === 'all';

  return (
    <Carousel
      responsive={responsive}
      infinite={true}
      arrows={false}
      renderButtonGroupOutside={true}
      customButtonGroup={<ButtonGroup />}
    >
      <Flex
        cursor="pointer"
        alignItems="center"
        p={4}
        bg="white"
        mx="auto"
        w="325px"
        height="70px"
        borderRadius="4px"
        border={allOffersSelected ? '1px solid #6873e5' : ''}
        boxShadow={
          allOffersSelected ? '0 2px 4px 0 rgba(180, 180, 180, 0.5)' : ''
        }
        justifyContent="center"
        fontWeight="bold"
        onClick={() => onSelectInfluencer('all')}
      >
        All Active Bet Offers
      </Flex>
      {INFLUENCERS.map((influencerScreenName) => (
        <InfluencerSelectCard
          selectedTwitterScreenName={
            allOffersSelected ? '' : selectedTwitterScreenName
          }
          twitterScreenName={influencerScreenName}
          onSelectInfluencer={onSelectInfluencer}
        />
      ))}
    </Carousel>
  );
};

export const ViewInfluencerBets = ({
  selectedTwitterScreenName,
  onSelectInfluencer,
}) => {
  const [twitterInfo, setTwitterInfo] = useState<any | undefined>();

  const [offers, setOffers] = useState<any[]>([]);
  const [pastOffers, setPastOffers] = useState<any[]>([]);

  const [allOffers, setAllOffers] = useState<any[]>();

  useEffect(() => {
    (async () => {
      setTwitterInfo(undefined);
      const twitterInfo = await getTwitterInfo(selectedTwitterScreenName);
      const offers: any[] = await getTowerService().getOffersByTwitter(
        twitterInfo.id_str
      );
      const acceptableOffers = offers.filter((offer) => offer.acceptable);
      const _pastOffers = offers.filter((offer) => !offer.acceptable);

      setTwitterInfo(twitterInfo);
      setOffers(acceptableOffers);
      setPastOffers(_pastOffers);
    })();
  }, [selectedTwitterScreenName]);

  useEffect(() => {
    // getAllOffers
    (async () => {
      const allActiveUsers = await getTowerService().getAllActiveUsers();

      setAllOffers(
        (
          await Promise.all(
            allActiveUsers.map(async ({ twitterId }) => {
              if (!twitterId) return [];
              const twitterInfo = await getTwitterInfoById(twitterId);
              const offers: any[] = await getTowerService().getOffersByTwitter(
                twitterInfo.id_str
              );
              const acceptableOffers = offers
                .filter((offer) => offer.acceptable)
                .map((offer) => Object.assign(offer, { twitterInfo }));
              return acceptableOffers;
            })
          )
        ).flat()
      );
    })();
  }, []);

  const allOffersSelected = selectedTwitterScreenName === 'all';

  return (
    <Box transform="translateY(-25px)">
      <Box
        justifyContent="center"
        mb="20px"
        position="relative"
        w={['700px', '700px', '700px', '1000px']}
        mx="auto"
      >
        <SelectInfluencerCarousel
          selectedTwitterScreenName={selectedTwitterScreenName}
          onSelectInfluencer={(args) => {
            onSelectInfluencer(args);
          }}
        />
      </Box>

      {new Date() > ELECTION_BETTING_END_DATE ? (
        <Flex
          alignItems="center"
          justifyContent="center"
          bg="#F6F6F6"
          h="200px"
        >
          <Heading
            fontWeight={500}
            size="md"
            color="#7c7c7c"
            textAlign="center"
          >
            Bets for the US Presidential Election are now closed.
            <br />
            Want to be an early user for our next launch?{' '}
            <Link
              ml={1}
              textDecoration="underline"
              color="blue.600"
              href="https://atomicfinance.typeform.com/to/xw7eZmLJ"
              target="_blank"
            >
              Sign up here!
            </Link>
          </Heading>
        </Flex>
      ) : twitterInfo &&
        (!allOffersSelected || (allOffersSelected && allOffers)) ? (
        <Grid
          m="0 auto"
          h="100%"
          w="70%"
          minW="800px"
          maxW="1280px"
          gridTemplateAreas='"select select" "user-info user-info"
            "bets bets" "request request"'
          gap="20px 20px"
          gridTemplateColumns="1fr 1fr"
          gridTemplateRows="min-content min-content 1fr"
        >
          {!allOffersSelected && (
            <Flex
              gridArea="user-info"
              bg="white"
              p={4}
              borderRadius="4px"
              justifyContent="center"
            >
              <Flex alignItems="center" maxWidth="500px">
                <Box
                  mr={4}
                  borderRadius={100}
                  boxSize="75px"
                  bg="#EBEBEB"
                  flexShrink={0}
                  background={`url(${twitterInfo.profile_image_url_https.replace(
                    'normal',
                    '200x200'
                  )})`}
                  backgroundSize="cover"
                ></Box>
                <Box>
                  <Box
                    h="20px"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    fontWeight="bold"
                    textOverflow="ellipsis"
                  >
                    {twitterInfo.name}
                  </Box>
                  <Box
                    w="100%"
                    fontSize="sm"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {twitterInfo.description}
                  </Box>
                </Box>
              </Flex>
            </Flex>
          )}
          {allOffersSelected ? (
            <AllOffersTable bets={allOffers} />
          ) : (
            <ViewOffers
              twitterInfo={twitterInfo}
              offers={offers}
              pastOffers={pastOffers}
            />
          )}

          {/* <Flex
            gridArea="request"
            alignItems="center"
            justifyContent="center"
            bg="rgba(91, 103, 231, 0.1)"
            borderRadius="4px"
            p={2}
          >
            <Text fontSize="sm" fontWeight="500">
              Want to be an <i>influencer</i> and create your own bets?{' '}
              <Link
                color="blue.600"
                target="_blank"
                href="https://atomicfinance.typeform.com/to/STTUZ3qz"
              >
                Submit a request!
              </Link>
            </Text>
          </Flex> */}
        </Grid>
      ) : (
        <Flex justifyContent="center" alignItems="center" boxSize="full" mt={4}>
          <BeatLoader />
        </Flex>
      )}
    </Box>
  );
};

const ViewInfluencerBetsContainer = () => {
  const { twitterScreenName } = useParams<ParamTypes>();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const history = useHistory();

  const onSelectInfluencer = (influencerTwitterScreenName) => {
    history.push(`/offers/${influencerTwitterScreenName}`);
  };

  useEffect(() => {
    console.log(twitterScreenName);
    setIsLoggedIn(!!localStorage.getItem('encryptedMnemonic'));
  }, [twitterScreenName]);

  return (
    <Box>
      <Header h="10rem" borderRadius="0 0 2px 2px">
        <Heading
          textAlign="center"
          color="white"
          minW="800px"
          fontSize={['lg', 'xl', '24px']}
        >
          Ready to put your Bitcoin where your mouth is? Pick a bet offer below
        </Heading>
        {isLoggedIn && (
          <Button
            bg="white"
            color="blue.600"
            borderColor="blue.600"
            borderWidth="1px"
            position="absolute"
            top="5"
            right="5"
            size="sm"
            colorScheme="white"
            onClick={() => history.push(`/dashboard`)}
          >
            Go to Dashboard
          </Button>
        )}
      </Header>

      <ViewInfluencerBets
        // key={twitterScreenName}
        selectedTwitterScreenName={twitterScreenName}
        onSelectInfluencer={onSelectInfluencer}
      />
    </Box>
  );
};

export default ViewInfluencerBetsContainer;
